import { useState } from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import useBoundStore from '../../store';
import Menu from 'components/menu';
import IconButton from 'components/icon-button';
import Button from 'components/button';
import { Tabs } from './components/tabs/Tabs';
import caretLeft from 'assets/images/caret-left.svg';
import styles from './styles.module.scss';
import { SellApartmentFlowPaths } from '../../routes';

const SellTabsSecondaryScreen = () => {
  const navigate = useNavigate();
  const screenPadding = useBoundStore((s) => s.screenPadding);
  const [houseId, setHouseId] = useState<number | undefined>(undefined);
  const [facilityCount, setFacilityCount] = useState<number | undefined>(undefined);

  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <div>
          <Menu />
          <IconButton icon={caretLeft} onClick={() => navigate(-1)} />
        </div>
        <div className={styles.headerContainer}>
          <h1 className={styles.title}>Выберете адрес</h1>
          <div className={styles.description}>Вторичное жилье</div>
        </div>
        <div>{''}</div>
      </header>

      <section
        style={{
          marginBottom: 0,
          height: `calc(100vh - ${screenPadding}px)`,
        }}
        className={clsx(styles.content)}
      >
        <Tabs setHouseId={setHouseId} setFacilityCount={setFacilityCount} houseId={houseId} footer={() => {
          return <footer className={clsx(styles.buttons, styles.footer, styles.floatingButtons)}>
            <Button
              label={'Продолжить'}
              onClick={() =>
                navigate(SellApartmentFlowPaths.chooseApartmentSecondary, {
                  state: { facilityCount },
                })
              }
              variant={'secondary'}
              disabled={!houseId}
            />
          </footer>
        }} />
      </section>

    </main>
  );
};

export default SellTabsSecondaryScreen;
